import { styled } from '@linaria/react';
import type { AgentSource } from '../../../api/events-client/events-client.type';
import { AGENT_SOURCES_ICONS, AGENT_SOURCES_LABELS } from '../../agentic-process/agentic-process.type';

type AgentSourceIconProps = {
  source: AgentSource;
  size?: number;
};

export function AgentSourceIcon({ source, size = 18 }: AgentSourceIconProps) {
  const icon = AGENT_SOURCES_ICONS[source];
  const label = AGENT_SOURCES_LABELS[source] ?? 'Unknown';
  if (!icon) {
    return (
      <Wrapper size={size} title={label}>
        <span aria-hidden="true">?</span>
      </Wrapper>
    );
  }
  return (
    <Wrapper size={size} title={label}>
      <SourceImg src={icon} alt={label} size={size} />
    </Wrapper>
  );
}

const Wrapper = styled.span<{ size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
`;

const SourceImg = styled.img<{ size: number }>`
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  object-fit: contain;
  display: block;
`;
